import methods from '@/services/methods'

export default {
  invalidCredits (payload) {
    return methods.sendGet(`virtual_accounts/invalid_credits`, payload, {noHyptoLoader: true})
  },
  search (payload) {
    return methods.sendGet(`virtual_accounts/invalid_credits/search`, payload, {restrictToast: true, noHyptoLoader: true})
  },
  export (payload) {
    return methods.sendGet(`virtual_accounts/invalid_credits/export`, payload)
  },
  refunds (id) {
    return methods.sendGet(`virtual_accounts/invalid_credits/${id}/refunds`)
  },
  refundStatus (id) {
    return methods.sendGet(`virtual_accounts/invalid_credits/${id}/refund_status`)
  },
  refundAction (id, payload) {
    return methods.sendPost(`virtual_accounts/invalid_credits/${id}/refund_action`, payload, {restrictToast: payload.perform === 'SETTLE_TO_NEW'})
  },
  bulkResendWebhook (payload) {
    return methods.sendPost(`virtual_accounts/invalid_credits/bulk_resend_webhook`, payload)
  },
  resendWebhook (id) {
    return methods.sendPost(`virtual_accounts/invalid_credits/${id}/resend_webhook`)
  }
}
